import React, { Component } from 'react';
import classNames from 'classnames';
import { MESSAGE_STATUS } from '../../../../constants';
import styles from './TextMessage.module.css';
import MessageMarkdown from '../../../Base/Utils/MessageMarkdown/MessageMarkdown';
export default class TextMessage extends Component {
    render() {
        const { text, status, invertColor, customColor } = this.props;
        return (React.createElement("p", { dir: "auto", className: classNames(styles.messageText, {
                [styles.deletedText]: status === MESSAGE_STATUS.MESSAGE_DELETED,
                [styles.whiteText]: invertColor,
            }), style: { color: customColor } },
            React.createElement(MessageMarkdown, { text: text })));
    }
}
